import { useQuery } from "@tanstack/react-query";
import { getPublicClinic } from "../api/getPublicClinic";
import { QUERY_KEYS } from "@/shared/api/query-keys";

export const usePublicClinic = (slug: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PUBLIC_CLINIC, slug],
    queryFn: () => getPublicClinic(slug),
    enabled: !!slug, // Evita disparar la petición si el slug no está listo en la URL
  });
};